<template>
    <div class="p-executive-dashboard__chart trend-charts">
        <div class="a-loader--chart u-full-width" v-if="loadingContent"></div>
        <div class="p-executive-dashboard__chart__no-results" v-if="!loadingContent && !hasResults">
            <p>Your search returned no results.</p>
        </div>
        <div class="trend-charts__line">
            <line-chart v-if="!loadingContent && hasResults" :chart-data="lineChartData"
                        :options="lineChartOptions"
                        :width="900">
            </line-chart>
        </div>
        <div class="trend-charts__legend u-full-width">
            <chart-legend v-if="showing !== 'total' && diseaseTypeSelected || !diseaseTypeSelected"
                          :columns="3"
                          :values="lineChartLabels"
                          :legendWidth="chartLegendWidth"
                          marginTop="60">
            </chart-legend>
        </div>
        <div>
            <div class="flex-grid flex-grid--reduced-bottom-margin">
                <div class="u-margin-top-20">
                    <option-filters>
                        <li :class="{'m-option-filters--active' : period === 'month'}"
                            @click="updateTrendsInReservesPeriod('month')">
                            Month
                        </li>
                        <li :class="{'m-option-filters--active' : period === 'quarter'}"
                            @click="updateTrendsInReservesPeriod('quarter')">
                            Quarter
                        </li>
                        <li :class="{'m-option-filters--active' : period === 'year'}"
                            @click="updateTrendsInReservesPeriod('year')">
                            Year
                        </li>
                    </option-filters>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import LineChart from 'components/graphs/LineChart';
    import OptionFilters from 'components/OptionFilters';
    import currencyFormat from "mixins/currencyFormat";
    import ChartLegend from 'components/chart/Legend.vue';
    import _ from 'lodash';

    export default {
        name: 'trends-chart',
        props: {
            chartData: {
                required: true,
                type: Object
            },
            type: {
                required: true,
                type: String
            },
            showing: {
                required: true,
                type: String
            },
        },
        mixins: [
            currencyFormat
        ],
        components: {
            LineChart,
            OptionFilters,
            ChartLegend
        },
        computed: {
            ...mapGetters('dashboards', [
                'getPeriod',
                'getRunning',
                'diseaseTypeSelected'
            ]),
            ...mapGetters('windowWidth', ['theCurrentWidth']),
            chartLegendWidth() {
                switch (true) {
                    case this.theCurrentWidth <= 700:
                        return 100;
                        break;
                    case this.theCurrentWidth <= 900:
                        return 90;
                        break;
                    case this.theCurrentWidth <= 1024:
                        return 70;
                        break;
                    default:
                        return 80;
                }
            },
            hasResults() {
                return !!this.chartData.data.length;
            },
            period: {
                get() {
                    return this.getPeriod('trendReserve')
                }
            },
            lineChartLabels() {
                return _.map(this.chartData.data, (value) => value.label)
            },
            lineChartData() {
                return {
                    labels: this.chartData.labels,
                    datasets: this.chartData.data,
                };
            },
            lineChartOptions() {
                return {
                    legend: {
                        display: false,
                        position: 'bottom',
                        labels: {
                            boxWidth: 60,
                            fontSize: 16,
                            fontFamily: "'Nunito', sans-serif",
                            fontColor: "#000",
                            padding: 20,
                        },
                    },
                    title: {
                        display: true,
                        text: '',
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                fontSize: 16,
                                fontFamily: "'Nunito', sans-serif",
                                fontColor: "#000",
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                fontSize: 16,
                                fontFamily: "'Nunito', sans-serif",
                                fontColor: "#000",
                                callback: (label) => {
                                    if (this.type !== 'number') {
                                        return this.currencyFormat(label, '£', 0);
                                    }

                                    if (Math.floor(label) === label) {
                                        return label;
                                    }
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: this.type === 'number' ? 'Number of Claims' : '',
                            },
                        }]
                    },
                    tooltips: {
                        mode: 'single',
                        callbacks: {
                            title: (item, items) => {
                                if (this.diseaseTypeSelected) {
                                    return items.labels[item[0].datasetIndex];
                                }
                                return items.labels[item[0].index];
                            },
                            labelColor: (item, items) => {
                                const datasetItem = this.lineChartData.datasets[item.datasetIndex];
                                return {
                                    borderColor: datasetItem.borderColor[0],
                                    backgroundColor: datasetItem.backgroundColor[0]
                                };
                            },
                            label: tooltipItems => {
                                if (this.type === 'value') {
                                    if (this.diseaseTypeSelected) {
                                        return this.currencyFormat(tooltipItems.yLabel, '£', 0);
                                    }
                                    return this.currencyFormat(tooltipItems.yLabel, '£', 0);
                                }
                                else {
                                    return tooltipItems.yLabel
                                }
                            }
                        }
                    },
                    hover: {mode: null},
                };
            },
            loadingContent() {
                return this.getRunning('trendReserve');
            }
        },
        methods: mapActions('dashboards', [
            'updateTrendsInReservesPeriod',
        ]),
    }
</script>


// WEBPACK FOOTER //
// TrendsChart.vue?3142bb74